import {get,post} from "@/utils/request.js"

/* 
	升级vip
 */
// 升级vip
export function insertEnterprise(data){
	return post('/admin/appCUser/insertEnterprise',data)
}

// 查询vip
export function selectUserEnterpriseInfo(data){
	return post('/admin/appCUser/selectUserEnterpriseInfo',data)
}